var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import Curriculum from '@/components/curriculum/Curriculum';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sortByKey } from '@/support/Object';
import { excludeRoles } from '@/support/ExcludeRoles';
import { Group as GroupModel } from '@/models/Group';
import AlertCard from '@/components/alert-card/AlertCard';
import DownloadIdpDialog from '@/components/curriculum/DownloadIdpDialog/DownloadIdpDialog';
import { RolesEnum } from '@/items/Roles';
import RemoveLdpDialog from '@/components/curriculum/RemoveLdpDialog/RemoveLdpDialog';
let Idp = class Idp extends Vue {
    constructor() {
        super(...arguments);
        this.curriculum = new CurriculumModel();
        this.isLoadingUserCurriculum = true;
        this.showDownloadIdp = false;
        this.showRemoveLdp = false;
    }
    beforeMount() {
        if (!this.exclude || this.isVersion('2') || this.isVersion('4')) {
            this.initialize();
            return;
        }
        return;
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoadingUserCurriculum = true;
        this.curriculum
            .current()
            .include(['children', 'subjects'])
            .first()
            .then((curriculum) => {
            this.curriculum = curriculum;
            const areas = this.curriculum.subjects || [];
            areas.forEach((area, index) => {
                this.curriculum.subjects[index] = this.curriculum.dataToModel(area, 'Subject');
                const topics = this.curriculum.subjects[index].children || [];
                topics.forEach((topic, i) => {
                    this.curriculum.subjects[index].children[i] = this.curriculum.dataToModel(topic, 'Subject');
                });
                topics.sort(sortByKey('name'));
                this.$set(this.curriculum.subjects[index], 'children', topics);
            });
            areas.sort(sortByKey('name'));
            this.$set(this.curriculum.subjects, 'subjects', areas);
            this.isLoadingUserCurriculum = false;
        });
    }
    isVersion(version) {
        return version == this.$store.state.version;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.detail.navigationItems.includes(this.$store.state.Auth.roles[0].id);
    }
    get version() {
        return this.$store.state.version;
    }
    get groupHasStudents() {
        const groupUsers = this.group.users;
        const students = groupUsers.filter((user) => {
            return !!user.roles && !!user.roles.find((role) => {
                return role.id === RolesEnum.STUDENT;
            });
        });
        return !!students.length;
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER]);
    }
};
__decorate([
    Model('group', { default: () => new GroupModel() }),
    __metadata("design:type", typeof (_a = typeof GroupModel !== "undefined" && GroupModel) === "function" ? _a : Object)
], Idp.prototype, "group", void 0);
Idp = __decorate([
    Component({
        components: {
            AlertCard,
            Curriculum,
            LoaderCard,
            PageHeader,
            DownloadIdpDialog,
            RemoveLdpDialog
        },
    })
], Idp);
export default Idp;
